import { render, staticRenderFns } from "./SectionNavigation.vue?vue&type=template&id=be593822&"
import script from "./SectionNavigation.vue?vue&type=script&lang=ts&"
export * from "./SectionNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports